import { render } from "./VillageWorld.vue?vue&type=template&id=8df0e564&scoped=true"
import script from "./VillageWorld.vue?vue&type=script&lang=js"
export * from "./VillageWorld.vue?vue&type=script&lang=js"

import "./VillageWorld.vue?vue&type=style&index=0&id=8df0e564&scoped=true&lang=scss"

import exportComponent from "/builds/arena/frontend/game-maplestory-landing/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8df0e564"]])

export default __exports__